import { useStaticQuery, graphql } from "gatsby";

export const useProductsOnlyQuery = () => {
	const data = useStaticQuery(graphql`
		query {
			allWpWhatWeDo(
				filter: { categories: { nodes: { elemMatch: { slug: { eq: "products" } } } } }
			) {
				edges {
					node {
						id
						uri
						title
						excerpt
						featuredImage {
							node {
								gatsbyImage(width: 300)
							}
						}
					}
				}
			}
		}
	`);
	return data;
};
